enum EnumLegalIdentificationStageType {
	None = 0,
	Company = 1,
	Beneficiary = 2,
	Director = 3,
	BusinessProfile = 4,
	Liveness = 5
}
export default EnumLegalIdentificationStageType
